import React from "react";

// hooks
import useOrderCreateFlow from "../../../../hooks/reduxContainer/fulfillment/orderCreateFlow";
import { useParams } from "react-router";

// libs
import { get } from "lodash-es";

// Components
import { OrderOverview } from "@secondcloset/web-components";

// Interfaces
import { Fulfillment } from "@secondcloset/types";
type Product = Fulfillment.Product;
type Address = Fulfillment.Order["address"];

const OrderOverviewStep = () => {
  const { activeCustomer, activeLocation, activeAddress, externalOrderNumber, notes, itemList, insuranceValue } =
    useOrderCreateFlow();
  const params = useParams();

  const organizationID = get(params, "organization_id");

  const onSkuClick = (product: Product) => {
    if (product) window.open(`/organizations/${organizationID}/products/${product.id}`);
  };

  return (
    <div>
      <OrderOverview
        address={activeAddress as Address}
        name={activeAddress?.contact_name || ""}
        email={activeCustomer?.email_address || ""}
        phone={activeCustomer?.phone_number || ""}
        externalOrderNumber={externalOrderNumber}
        fulfilledFrom={activeLocation}
        insuranceValue={insuranceValue}
        notes={notes}
        itemList={itemList}
        onSkuClick={onSkuClick}
      />
    </div>
  );
};

export default OrderOverviewStep;
